module.exports = __webpack_public_path__ + "assets/img/keitaro.fb01cad8.svg";